import { createI18n } from 'vue-i18n'
import type { Locale } from '@/config/tenants'
import de from './locales/de.json'
import en from './locales/en.json'

const STORAGE_KEY = 'partner.locale'

export const i18n = createI18n<false>({
  legacy: false,
  locale: 'de',
  fallbackLocale: 'de',
  messages: { de, en },
})

export function setAppLocale(locale: Locale): void {
  i18n.global.locale.value = locale
  document.documentElement.lang = locale
  try {
    localStorage.setItem(STORAGE_KEY, locale)
  } catch {
    /* storage unavailable (private mode) - locale just resets next visit */
  }
}

export function getStoredLocale(): Locale | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY)
    return value === 'de' || value === 'en' ? value : null
  } catch {
    return null
  }
}

/* Browser preference (Accept-Language order) - used when the user has not
   chosen a locale yet. */
export function getBrowserLocale(): Locale | null {
  for (const lang of navigator.languages ?? []) {
    const short = lang.slice(0, 2).toLowerCase()
    if (short === 'de' || short === 'en') return short
  }
  return null
}
